module.exports = __webpack_public_path__ + "img/nav-1-1.2ea5b33f.png";